import React, { useEffect, useState } from 'react';
import { justoAPI } from '@/lib/justo';
import { EnviosTable } from './EnviosTable';

export const PendientesTab = () => {
  const [data, setData] = useState(null);
  const load = () => justoAPI.pendientes().then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  if (!data) return <p className="text-slate-500 mt-4">Cargando...</p>;
  return (
    <div className="space-y-5 mt-4" data-testid="justo-pendientes">
      <p className="text-sm text-slate-600" data-testid="justo-pendientes-total">
        {data.total === 0 ? 'No hay envíos pendientes de subir a Justo en los últimos 14 días.' : `${data.total} envíos de los últimos 14 días sin marcar como subidos a Justo`}
      </p>
      {data.grupos.map((g) => (
        <div key={g.destino} className="space-y-2" data-testid={`justo-pendientes-grupo-${g.destino}`}>
          <h3 className="font-semibold text-slate-800">{g.destino} <span className="text-sm font-normal text-slate-500">({g.envios.length})</span></h3>
          <EnviosTable envios={g.envios} onChanged={load} />
        </div>
      ))}
    </div>
  );
};
